module.exports = __webpack_public_path__ + "static/brokerage-accounts-services-hero.7001aa4c.webp";